import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, INDUSTRIES_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'allIndustry',
  pluralName: 'allIndustries',
  url: `${INDUSTRIES_URL}/all`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
